/** Windows app-window titlebar (cosmetic min/restore/close) for the OS look. */
export function WindowTitlebar({ title }: { title: string }) {
  return (
    <div className="win-titlebar">
      <span className="win-titlebar-name">{title}</span>
      <span className="win-titlebar-controls" aria-hidden="true">
        <i className="wt min">{"\u2013"}</i>
        <i className="wt max">{"\u25A1"}</i>
        <i className="wt close">{"\u2715"}</i>
      </span>
    </div>
  );
}
